import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import TableCell from "@mui/material/TableCell";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import ButtonGroup from "@mui/material/ButtonGroup";
import DeleteIcon from "@mui/icons-material/Delete";
import Autocomplete from "@mui/material/Autocomplete";

import { columns, emptyVan } from "./common";

export default function VanEditableTableRow({ row, drivers, actions }) {
	const [trackId, setTrackId] = React.useState(row.trackId);
	const [model, setModel] = React.useState(row.model);
	const [number, setNumber] = React.useState(row.number);
	const [user, setUser] = React.useState(row.user);

	const handleSaveRowClick = () => {
		actions.saveRow({
			id: row.id,
			trackId,
			userId: user ? user.id : null,
			model,
			number,
		});
	};

	const handleCancelEditRowClick = () => {
		actions.cancelEdit(row.id);
	};

	const handleDeleteRowClick = () => {
		actions.tryDeleteRow(row.id);
	};

	const textInput = ({ value, setValue, disabled = false }) => (
		<TextField
			inputRef={(input) => input}
			sx={{
				width: "25ch",
				"& .Mui-focused": {
					width: "22ch",
				},
				"& .MuiInputBase-input": {
					width: "100%",
					height: 0,
				},
			}}
			variant="outlined"
			onChange={(event) => setValue(event.target.value)}
			value={value}
			disabled={disabled}
			inputProps={{ "aria-label": "value" }}
		/>
	);
	return (
		<>
			<TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
				{columns.map((column) => (
					<TableCell key={column.id} align={column.align}>
						{column.id === "buttons" && (
							<div>
								<div style={{ display: "flex", gap: 15 }}>
									<ButtonGroup
										variant="outlined"
										aria-label="outlined button group"
									>
										<Button
											onClick={() => handleSaveRowClick()}
											disabled={!trackId || !model}
										>
											<SaveIcon />
										</Button>
										<Button
											color="error"
											onClick={() => handleDeleteRowClick()}
											disabled={row.id === emptyVan.id}
										>
											<DeleteIcon />
										</Button>
										<Button
											color="error"
											onClick={() => handleCancelEditRowClick()}
										>
											<CloseIcon />
										</Button>
									</ButtonGroup>
								</div>
							</div>
						)}
						{column.id === "trackId" &&
							textInput({ value: trackId, setValue: setTrackId })}
						{column.id === "model" &&
							textInput({ value: model, setValue: setModel })}
						{column.id === "number" &&
							textInput({ value: number, setValue: setNumber })}
						{column.id === "driver" && (
							<Box sx={{ minWidth: 250 }}>
								{drivers && (
									<Autocomplete
										options={drivers}
										getOptionLabel={(option) => option.name}
										id="van-driver-select"
										clearOnEscape
										value={user}
										onChange={(e, selectedValue) => setUser(selectedValue)}
										renderInput={(params) => (
											<TextField {...params} label="Водій" variant="outlined" />
										)}
									/>
								)}
							</Box>
						)}
					</TableCell>
				))}
			</TableRow>
		</>
	);
}
